import 'css-chunksrc/client/pages/documentsPage/documentsPage/preview/zipRenderer/nodes/styles.scss';export default {
  "parentNode": "_parentNode_ta8gg_1",
  "backArrow": "_backArrow_ta8gg_11",
  "name": "_name_ta8gg_17",
  "list": "_list_ta8gg_23",
  "node": "_node_ta8gg_28"
};